export const DEFAULT_CATEGORY_NAME = '__default__';
export const DEFAULT_CUSTOMER_NAME = 'customer';

export const NO_SHOW_MARK = 'NO_SHOW';

export const FIRST_AVAILABLE_STAFF_ID = -1;

export const DEFAULT_DURATION_IN_MINUTES = 60;

export const REFRESH_DATA_INTERVAL = 10 * 60 * 1000; // 10 minutes
export const ABLE_TO_CHECKIN_BEFORE_MINUTES = 30; // minutes

export const VALUE_CHANGES_DEBOUNCE = 100; // ms
export const DEBOUNCE_TIME = 500; // ms

export const NOTIFICATION_HISTORY_IN_DAYS = 3; // days
